import { type FeatureModule } from '@store/features/types';

export const clinicDocumentsFeature: FeatureModule = {
  id: 'clinicDocuments',
  name: 'Clinic Documents',
  dependencies: [],
  reducers: {},
  middleware: [],
  persistence: { enabled: false },
  sync: { enabled: false },
  setup: _store => {},
  cleanup: _store => {},
};
